module.exports = __webpack_public_path__ + "static/media/1004940.167db8e1.png";